import * as React from 'react';
import { AutocompleteArrayInput } from 'react-admin';

export const NameAutocompleteArrayInput = props => {
  // We need to reassign component value to alter component behavior.
  // eslint-disable-next-line no-param-reassign,react/destructuring-assignment
  props.input.value = props.input.value ? [...new Set(props.input.value.map(e => e.id || e))] : [];
  return <AutocompleteArrayInput {...props} />;
};
